import * as yup from 'yup'

export const schemaUpdateContractProcessModal = yup.object().shape({
    contract: yup.object().shape({
        contract_number_id: yup.string().required(),
        customer_id: yup.number().required(),
        contract_value: yup.number().required(),
        contract_status: yup.string().required(),
        contract_role: yup
            .string()
            .oneOf([
                'customer',
                'supplier',
                'reseller',
                'affiliate',
                'collaborator',
            ])
            .required(),
        contract_direction: yup.string().oneOf(['earn', 'pay']).required(),
        contract_effective_date: yup.string().required(),
        contract_expiry_date: yup.string().required(),
        partner_id: yup.number().nullable(),
    }),
})
